<template>
  <div class="pr-2">
    <template
      v-if="db_line_items && db_line_items.length && db_line_items.length > 0"
    >
      <div class="my-3">
        <div class="d-flex align-center justify-end">
          <!-- <v-checkbox
            v-if="
              !isEnquiry &&
              !isInvoice &&
              !isQuotation &&
              !isPreventive &&
              !isProject
            "
            readonly
            class="my-0 py-0"
            v-model="showPrice"
            color="cyan white--text"
            label="Show Price To Engineer"
          /> -->
          <!-- <div class="px-3">
          <span class="ml-2">Show Price To Engineer : &nbsp;</span>
          <template v-if="showPrice">
            <v-chip color="green" small outlined label>
              <span class="">YES</span>
            </v-chip>
          </template>
          <template v-else>
            <v-chip color="red" small outlined label>
              <span class=""> NO</span>
            </v-chip>
          </template>
        </div> -->
          <div
            class="d-flex align-center ml-4 pl-4 custom-border-left"
            v-if="false"
          >
            <div class="mr-2">
              <label for="discount-level" class="mb-0 font-weight-600"
                >Discount Level</label
              >
            </div>
            <div>
              <v-radio-group
                readonly
                id="discount-level"
                v-model="discountLevel"
                row
                hide-details
                class="px-0 py-0"
              >
                <v-radio
                  label="Line Item"
                  value="line_item"
                  color="cyan"
                ></v-radio>
                <v-radio
                  label="Transaction"
                  value="transaction"
                  color="cyan"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex grey lighten-4 px-2"
        style="border-bottom: solid 1px #e4e3e3 !important"
      >
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 5%"
        >
          #
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-left"
          :style="get_col_style('product')"
        >
          Customer Asset / Own Asset
        </div>
        <!-- <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 10%"
        >
          Selling/Unit Cost
        </div> -->
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 10%"
        >
          UOM
        </div>
        <!--  <div
          v-if="discountLevel == 'line_item'"
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 15%"
        >
          Discount
        </div> -->
        <!-- <div
          class="color-custom-blue py-2 font-weight-600 text-right"
          style="width: 10%"
        >
          Total
        </div> -->
      </div>
      <div
        v-for="(row, index) in db_line_items"
        class="line-item-drag"
        :key="`line-item-drag-${index}`"
        :class="`${row.class} ${row.type == 'header' ? '' : ''}`"
      >
        <div
          :id="`line-item-drag-${index}`"
          class="d-flex py-1 px-2"
          :class="{ 'item-is-child': row.is_child }"
        >
          <div
            class="font-weight-600 text-center"
            style="width: 5%"
            v-if="row.product_type != 'header'"
          >
            <template>
              <div
                class="font-weight-600 mt-0"
                style="font-size: 15px"
                v-if="!row.is_child"
              >
                {{ row.sno }}.
              </div>
            </template>
          </div>
          <div
            class="font-weight-600 text-center"
            style="width: 5%"
            v-if="row.is_child"
          >
            <template>
              <div class="font-weight-600 mt-0" style="font-size: 15px">
                {{ row.sno }}.
              </div>
            </template>
          </div>
          <div
            v-if="row.type == 'header'"
            class="text-left"
            style="width: 100%"
          >
            <div class="d-flex">
              <div
                class="font-weight-600"
                style="font-size: 15px; margin-left: 24px"
              >
                {{ row.product }}
              </div>

              <div class="text-center" style="width: 50%"></div>
              <!-- <v-chip
              color="cyan white--text"
              label
              class="lip-type text-uppercase font-weight-600 header"
            >
              Header
            </v-chip> -->
            </div>
          </div>
          <div
            v-else
            class="text-left"
            :style="get_col_style('product', row.is_child)"
          >
            <div class="d-flex">
              <v-avatar size="32" v-if="row.product_type != 'other'">
                <img
                  v-if="row?.image?.url"
                  :src="row?.image?.url"
                  :alt="row?.image?.name"
                />
                <img v-else :src="$defaultImage" />
              </v-avatar>
              <div style="width: 100%" class="ml-2">
                <v-expansion-panels class="cepfli">
                  <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-header>
                      <div class="d-flex">
                        <span class="font-weight-600 font-size-18">
                          {{ row.product }}
                        </span>
                        <v-spacer></v-spacer>
                        <!--    <div>
                            <v-tooltip
                              top
                              content-class="custom-top-tooltip"
                              v-if="row && row.trip && row.trip.barcode"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  label
                                  color="chip-custom-blue"
                                  outlined
                                  small
                                >
                                  {{ row.trip.barcode }}
                                </v-chip>
                              </template>
                              <span class="text-uppercase"> Visit Trip Id </span>
                            </v-tooltip>
                          </div> -->
                        <div style="width: 150px; text-align: end">
                          <v-chip
                            v-if="row.type != 'other'"
                            class="lip-type mr-2 custom-btn-color"
                            color="white--text"
                            label
                          >
                            <v-icon small @click.stop="openYearCostDialog(row)">
                              mdi-cog
                            </v-icon>
                          </v-chip>
                          <v-tooltip top content-class="custom-top-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                color="cyan white--text"
                                label
                                class="lip-type text-uppercase font-weight-600"
                                :class="{
                                  product: row.product_type == 'goods',
                                  service: row.product_type == 'service',
                                  equipment: row.product_type == 'equipment',
                                  parts: row.product_type == 'parts',
                                  tools: row.product_type == 'tools',
                                  other: row.product_type == 'other',
                                  asset: row.product_type == 'asset',
                                }"
                              >
                                <template v-if="row.type == 'tools'">
                                  T</template
                                >
                                <template v-else-if="row.type == 'parts'">
                                  PR</template
                                >
                                <template v-else-if="row.type == 'equipment'">
                                  CA</template
                                >
                                <template v-else-if="row.type == 'asset'">
                                  OA</template
                                >
                                <template v-else>
                                  {{ row.type.charAt(0) }}</template
                                >
                              </v-chip>
                            </template>

                            <span class="text-uppercase">
                              <template v-if="row.type == 'tools'">
                                Tools</template
                              >
                              <template v-else-if="row.type == 'equipment'">
                                Customer Asset</template
                              >
                              <template v-else-if="row.type == 'asset'">
                                Own Asset</template
                              >
                              <template v-else> {{ row.type }}</template>
                            </span>
                          </v-tooltip>
                          <v-tooltip
                            top
                            content-class="custom-top-tooltip"
                            v-if="row.type != 'other'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                class="lip-type ml-2"
                                color="orange"
                                label
                              >
                                <v-icon
                                  small
                                  v-on:click="openrenewalLiftDialog(row)"
                                  style="color: white !important"
                                >
                                  mdi-orbit-variant
                                </v-icon>
                              </v-chip>
                            </template>
                            <span>Annual Lift Certificate Renewal-Lift</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <span class="ml-n6">
                        <template v-if="row.description">{{
                          row.description
                        }}</template>
                        <em v-else class="text-muted"> no description</em>
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <div
                  v-if="row && row.item_images && row.item_images.length"
                  class="d-flex"
                >
                  <div
                    style="position: relative"
                    v-for="(nimg, nmlindex) in row.item_images"
                    :key="`new-image-${nmlindex}`"
                  >
                    <v-img
                      :aspect-ratio="1"
                      height="100px"
                      width="100px"
                      class="mr-4 my-2"
                      :src="nimg"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey darken-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                </div>
                <v-checkbox
                  v-if="row.type == 'product' && row.is_equipment == 1"
                  inset
                  color="cyan"
                  label="As Customer Asset"
                  dense
                  disabled
                  class="pt-0 mt-2"
                  v-model="row.is_equipment"
                  hide-details
                  :false-value="0"
                  :true-value="1"
                >
                </v-checkbox>
                <div class="font-weight-600 d-flex align-center mt-0">
                  <template>
                    <v-chip
                      v-if="row.barcode"
                      label
                      color="chip-custom-blue"
                      outlined
                      small
                      class="text-white p-3 mt-1 mb-0"
                      style="font-weight: 700"
                      v-on:click="routeToDetail(row)"
                      >{{ row.barcode }}</v-chip
                    >
                    <template v-if="isWarranty(row)">
                      <v-chip
                        :color="getWarrantyStatusColor(row.warranty_status)"
                        small
                        text-color="white"
                        class="text-white p-3 mt-2 mb-1 ml-2"
                      >
                        Warranty
                      </v-chip>
                    </template>
                    <template
                      v-if="
                        row.product_type == 'equipment' &&
                        row &&
                        row.preventive_id &&
                        row.preventive_barcode &&
                        row.preventive_id > 0 &&
                        false
                      "
                    >
                      <v-chip
                        :color="row?.is_consumed ? 'red' : 'lightgray'"
                        class="p-3 mt-1 mb-0 ml-2"
                        small
                        text-color=""
                        outlined
                        v-on:click.prevent.stop="
                          routeToDetailLink(
                            row.preventive_id,
                            'admin.preventive-maintanance.detail'
                          )
                        "
                      >
                        {{ row.preventive_barcode }}
                      </v-chip>
                    </template>
                    <!--  <v-chip
                      label
                      color="chip-custom-blue"
                      outlined
                      small
                      class="text-white p-3 mr-2"
                      v-on:click="routeToDetail(row)"
                      style="font-weight: 700; margin-top: -6px"
                      >{{ row.barcode }}</v-chip
                    > -->
                  </template>
                  <!-- <template v-if="row?.property?.parent?.name">
                    <v-chip small label>{{ row.property.parent.name }}</v-chip>
                    <v-icon class="px-1">mdi-chevron-right</v-icon>
                  </template>
                  <template v-if="row?.property?.child?.name">
                    <v-chip small label>{{ row.property.child.name }}</v-chip>
                    <v-icon class="px-1">mdi-chevron-right</v-icon>
                  </template>
                  <template v-if="row?.property?.type == 'child-child-'">
                    <v-chip small label style="padding: 10px !important">
                      <div>
                        <div>
                          {{ row?.property?.property_name }}
                        </div>
                        <div>{{ row.property.name }}</div>
                      </div>
                    </v-chip>
                  </template>
                  <template v-if="row?.property?.type == 'child-'">
                    <v-chip small label style="padding: 10px !important">
                      <div>
                        <div>
                          {{ row?.property?.property_name }}
                        </div>
                        <div>{{ row.property.name }}</div>
                      </div>
                    </v-chip>
                  </template>
                  <template v-if="row?.property?.type == 'parent-'">
                    <v-chip small style="padding: 10px !important">
                      <div>
                        <div>
                          {{ row?.property?.property_name }}
                        </div>
                        <div>{{ row.property.name }}</div>
                      </div>
                    </v-chip>
                  </template> -->
                  <v-spacer></v-spacer>
                  <v-tooltip
                    top
                    content-class="custom-top-tooltip"
                    v-if="
                      row?.serialize_number?.length > 0 &&
                      (row.product_type == 'goods' ||
                        row.product_type == 'parts') &&
                      false
                    "
                    class="mr-8"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        v-on:click="optionSerial(row)"
                        color="white--text"
                      >
                        mdi-pound
                      </v-icon>
                    </template>
                    ({{ row?.serialize_number?.length }})
                    <span class="text-uppercase"> View Serial Numbers </span>
                  </v-tooltip>
                  <template
                    v-if="
                      row?.serialize_number?.length > 0 &&
                      (row.product_type == 'goods' ||
                        row.product_type == 'parts') &&
                      false
                    "
                    >({{ row?.serialize_number?.length }})</template
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            class="text-center"
            style="width: 10%"
            v-if="!(row.type == 'header')"
          >
            <div class="text-center">{{ row.rate }}</div>
          </div> -->
          <div
            class="text-center"
            style="width: 10%"
            v-if="!(row.type == 'header')"
          >
            <div>
              <!--  {{ row.quantity }} -->

              <span v-if="row?.uom">{{ row.uom }}</span>
              <em class="text-muted" v-else>no uom </em>
            </div>
          </div>
          <!-- <div
            class="text-center"
            style="width: 15%"
            v-if="discountLevel == 'line_item' && !(row.type == 'header')"
          >
            <div class="d-flex">
              <v-text-field
                readonly
                hide-details
                class="line-item-header-text px-0"
                placeholder="Discount"
                dense
                filled
                solo
                flat
                type="number"
                v-model="row.discount_value"
                color="cyan"
                style="width: 50%; min-width: unset"
              />
              <v-select
                readonly
                :items="discount_type_list"
                v-model="row.discount_type"
                hide-details
                item-text="type"
                item-value="value"
                item-color="cyan"
                class="line-item-header-text discount-type text-h6 px-0"
                placeholder="Type"
                dense
                filled
                solo
                flat
                color="cyan"
                style="width: 50%"
              />
            </div>
          </div> -->
          <!-- <div
            class="text-center"
            style="width: 10%"
            v-if="!(row.type == 'header')"
          >
            <div class="text-right">{{ row.total }}</div>
          </div> -->
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex align-center justify-center mt-2">
        <img
          :src="$assetURL('media/error/empty.png')"
          class="row-not-found-image"
        />
        Uhh... There are no line items at the moment.
      </div>
    </template>
    <ViewSerialNumber
      v-if="seleceDialog"
      :transaction-detail="transactionDetail"
      :dialogStatus="seleceDialog"
      v-on:close:dialog="seleceDialog = false"
    >
    </ViewSerialNumber>

    <Dialog :commonDialog="renewalLiftDialog" style="width: 600px">
      <template v-slot:title>
        <div class="text-h6">
          {{
            qty_object?.machine_number
              ? qty_object?.machine_number + " - "
              : ""
          }}{{ qty_object?.product }}
        </div>
      </template>
      <template v-slot:body>
        <v-form ref="form">
          <div class="custom-grey-border">
            <table width="100%" style="table-layout: fixed">
              <thead>
                <tr>
                  <th
                    class="font-weight-700 color-custom-blue grey lighten-4 text-uppercase pl-4"
                  >
                    Lift Test
                  </th>
                  <th
                    class="font-weight-700 color-custom-blue grey lighten-4 text-uppercase pl-4"
                  >
                    Amount
                  </th>
                  <!--  <th
                    class="text-left font-weight-700 color-custom-blue grey lighten-4 text-uppercase pl-4"
                  >
                    Qty
                  </th>
                  <th
                    class="text-left font-weight-700 color-custom-blue grey lighten-4 text-uppercase pl-4"
                  >
                    Total
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in qty_object.renewal_lift_cost"
                  :key="`door-type-qty-row-${index}`"
                  class="alternate-listing-row custom-border-top"
                >
                  <td>
                    <span class="ml-2 text-capitalize">
                      <b>
                        {{ row?.lift_test?.replaceAll("-", " ") }}
                      </b>
                    </span>
                  </td>
                  <td>
                    <span class="ml-2">
                      <b>
                        {{ formatMoney(row?.unit_cost) }}
                      </b>
                    </span>
                  </td>

                  <!--  <td>
                     <span class="ml-2">
                        <b>
                       {{ row?.quantity}}
                    </b>
                   
                    </span>
                  </td>
                  <td>
                    <span class="ml-2">
                        <b>
                         {{ formatMoney(row?.total)}}
                       </b>
                    </span>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="renewalLiftDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>

    <Dialog :commonDialog="yearCostDialog" style="width: 600px">
      <template v-slot:title>
        <div class="text-h6">
          {{ barCode ? barCode + " - " : "" }}{{ selectedLineItem?.product }}
        </div>
      </template>
      <template v-slot:body>
        <v-row
          v-for="(entry, key) in selectedLineItem?.yearly_costs"
          :key="key"
          align="center"
        >
          <v-col cols="12" sm="2">
            <div>
              <div v-if="key === 0">
                <label
                  class="ml-2 mb-5"
                  style="font-size: 16px; font-weight: 600; margin-left: 2px"
                  >Year</label
                >
              </div>
              <strong>
                <label
                  class="ml-2"
                  :for="`year-cost-${key}`"
                  style="font-size: 14px"
                >
                  {{ getOrdinalSuffix(entry.year) }} Year
                </label>
              </strong>
            </div>
          </v-col>

          <v-col cols="12" sm="3">
            <div v-if="key === 0">
              <label
                for="cost-field"
                style="font-size: 16px; font-weight: 600; margin-left: 2"
                >Cost</label
              >
            </div>

            <v-text-field
              v-model="entry.cost"
              :id="`year-cost-${key}`"
              type="number"
              dense
              color="cyan"
              filled
              solo
              flat
              hide-details
              placeholder="Cost"
              :style="key === 0 ? 'margin-top:6px;' : ''"
              prefix="$"
              readonly
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="yearCostDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import ViewSerialNumber from "@/view/pages/partials/View-Serial-Number.vue";
import Dialog from "@/view/pages/partials/Dialog";
import CommonMixin from "@/core/plugins/common-mixin";

export default {
  mixins: [CommonMixin],
  name: "visit-line-item",
  props: {
    showPrice: {
      type: Boolean,
      default: false,
    },
    discountLevel: {
      type: String,
      default: "transaction",
    },
    relatedId: {
      type: Number,
      default: 0,
    },
    isEnquiry: {
      type: Boolean,
      default: false,
    },
    isQuotation: {
      type: Boolean,
      default: false,
    },
    isPreventive: {
      type: Boolean,
      default: false,
    },
    isInvoice: {
      type: Boolean,
      default: false,
    },
    relatedType: {
      type: Number,
      default: 0,
    },

    isProject: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      db_line_items: [],
      discount_type_list: [
        { type: "%", value: "2" },
        { type: "$", value: "1" },
      ],
      sno: 1,
      loading: false,
      transactionDetail: {},
      seleceDialog: false,
      yearCostDialog: false,
      selectedLineItem: null,
      qty_object: {},
      renewalLiftDialog: false,
    };
  },
  methods: {
    optionSerial(row) {
      this.transactionDetail = row;
      this.seleceDialog = true;
    },

    formatKey(key) {
      const match = key.match(/^([a-zA-Z]+)(\d+)$/);
      if (match) {
        const [, letters, numbers] = match;
        return `${this.capitalize(letters)} ${numbers}`;
      }
      return this.capitalize(key);
    },

    getOrdinalSuffix(n) {
      const lastDigit = n % 10;
      const lastTwoDigits = n % 100;

      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return n + "th";
      }

      switch (lastDigit) {
        case 1:
          return n + "st";
        case 2:
          return n + "nd";
        case 3:
          return n + "rd";
        default:
          return n + "th";
      }
    },

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    openYearCostDialog(row) {
      this.selectedLineItem = row;
      this.yearCostDialog = true;
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    openrenewalLiftDialog(row) {
      this.qty_object = row;
      this.renewalLiftDialog = true;
    },
    routeToDetail(data) {
      let routeName = null;
      if (data.product_type == "equipment") {
        routeName = "client-equipment.detail";
      } else if (data.product_type == "tools") {
        routeName = "equipment.detail";
      } else if (data.product_type == "asset") {
        routeName = "asset-equipment.detail";
      } else if (data.product_type == "goods") {
        routeName = "product.detail";
      } else if (data.product_type == "service") {
        routeName = "service.detail";
      } else if (data.product_type == "parts") {
        routeName = "part.detail";
      }
      if (data && data.product_id && data.product_id > 0) {
        this.$router.replace(
          this.getDefaultRoute(routeName, {
            params: { id: data.product_id },
          })
        );
      }
    },
    get_line_items() {
      this.loading = true;
      this.$store
        .dispatch(QUERY, {
          url: `detail-iteam/${this.relatedId}/line-items`,
          data: {
            type: this.relatedType,
          },
        })
        .then(({ data }) => {
          this.db_line_items = data;
          this.$emit("line-item", this.db_line_items.length);
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    get_col_style(param, child) {
      let width = 55;
      if (param == "product") {
        if (!this.showPrice) {
          width = 85;
        } else if (this.showPrice) {
          width = 55;
          if (this.discountLevel == "transaction") {
            width = 85;
          }
        }
      }
      return { width: child ? `${width}%` : `${width}%` };
    },
    /*  get_col_style(param, child) {
      let width = 46;
      if (param == "product") {
        if (!this.show_price) {
          width = 70;
        } else if (this.show_price) {
          width = 46;
          if (this.discount_level == "transaction") {
            width = 70;
          }
        }
      }
      return { width: child ? `${width - 5}%` : `${width}%` };
    }, */
  },
  mounted() {
    this.get_line_items();
  },
  computed: {
    getSN: () => {
      return function (row, index) {
        if (index == 0) {
          this.sno = 1;
          console.log();
        }
        if (row.product_type == "header") {
          this.sno = 1;
        } else {
          this.sno = this.sno + 1;
        }
      };
    },

    barCode() {
      const barcode = this.selectedLineItem?.machine_number;
      return barcode ? barcode.replace(/\s*-\s*/g, "") : null;
    },
  },
  components: {
    ViewSerialNumber,
    Dialog,
  },
};
</script>
